jQuery(function() {
    $('#profile-main-user-c-o-i-requirements-form').dirrty({
        preventLeaving: false
    }).on("dirty", function () {
        $('#coireq-submit').removeAttr('disabled');

    }).on("clean", function () {
        $('#coireq-submit').attr('disabled', 'disabled');
    });

    $('#account_form').dirrty({
        preventLeaving: false

    }).on("dirty", function () {
        $('#update_password_button').removeAttr('disabled');

    }).on("clean", function () {
        $('#update_password_button').attr('disabled', 'disabled');
    });


    $('#company_form').dirrty({
        preventLeaving: false

    }).on("dirty", function () {
        $('#company_submit_button').removeAttr('disabled');

    }).on("clean", function () {
        $('#company_submit_button').attr('disabled', 'disabled');
    });

    $('#credit_card_update').dirrty({
        preventLeaving: false

    }).on("dirty", function () {
        $('#credit_card_update_button').removeAttr('disabled');

    }).on("clean", function () {
        $('#credit_card_update_button').attr('disabled', 'disabled');
    });

    $('#notification_form').dirrty({
        preventLeaving: false

    }).on("dirty", function () {
        $('#notification_form_button').removeAttr('disabled');

    }).on("clean", function () {
        $('#notification_form_button').attr('disabled', 'disabled');
    });
});
